import { s as spacing } from '../base/spacing-zNVNrnl_.js';

/* eslint-disable id-length */
const pagination = {
  paginationItemMargin: spacing.medium,
  paginationNavGroupMargin: spacing.mini,
  button: {
    width: '31px'
  }
};
const mobilePagination = {
  mobile: {
    paginationItemMargin: '8px'
  },
  button: {
    mobile: {
      width: '40px',
      height: '44px'
    }
  }
};

export { mobilePagination as m, pagination as p };
//# sourceMappingURL=pagination-Bf5FM4AC.js.map
